/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CustomMetric } from './CustomMetric';
import {
    CustomMetricFromJSON,
    CustomMetricFromJSONTyped,
    CustomMetricToJSON,
} from './CustomMetric';
import type { View } from './View';
import {
    ViewFromJSON,
    ViewFromJSONTyped,
    ViewToJSON,
} from './View';
import type { XAxis } from './XAxis';
import {
    XAxisFromJSON,
    XAxisFromJSONTyped,
    XAxisToJSON,
} from './XAxis';

/**
 * 
 * @export
 * @interface HistogramSeriesViewRequest
 */
export interface HistogramSeriesViewRequest {
    /**
     * The max number of bins should be greater than 2.
     * @type {number}
     * @memberof HistogramSeriesViewRequest
     */
    maxNumberOfBins: number;
    /**
     * 
     * @type {Array<CustomMetric>}
     * @memberof HistogramSeriesViewRequest
     */
    metrics: Array<CustomMetric>;
    /**
     * 
     * @type {View}
     * @memberof HistogramSeriesViewRequest
     */
    view: View;
    /**
     * 
     * @type {XAxis}
     * @memberof HistogramSeriesViewRequest
     */
    xaxis: XAxis;
}

/**
 * Check if a given object implements the HistogramSeriesViewRequest interface.
 */
export function instanceOfHistogramSeriesViewRequest(value: object): value is HistogramSeriesViewRequest {
    if (!('maxNumberOfBins' in value) || value['maxNumberOfBins'] === undefined) return false;
    if (!('metrics' in value) || value['metrics'] === undefined) return false;
    if (!('view' in value) || value['view'] === undefined) return false;
    if (!('xaxis' in value) || value['xaxis'] === undefined) return false;
    return true;
}

export function HistogramSeriesViewRequestFromJSON(json: any): HistogramSeriesViewRequest {
    return HistogramSeriesViewRequestFromJSONTyped(json, false);
}

export function HistogramSeriesViewRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): HistogramSeriesViewRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'maxNumberOfBins': json['maxNumberOfBins'],
        'metrics': ((json['metrics'] as Array<any>).map(CustomMetricFromJSON)),
        'view': ViewFromJSON(json['view']),
        'xaxis': XAxisFromJSON(json['xaxis']),
    };
}

export function HistogramSeriesViewRequestToJSON(value?: HistogramSeriesViewRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'maxNumberOfBins': value['maxNumberOfBins'],
        'metrics': ((value['metrics'] as Array<any>).map(CustomMetricToJSON)),
        'view': ViewToJSON(value['view']),
        'xaxis': XAxisToJSON(value['xaxis']),
    };
}

